export default __webpack_public_path__ + "static/media/percorso-conte.3123bdc5.jpg";